import { render, staticRenderFns } from "./setting-email.vue?vue&type=template&id=d7964c04&scoped=true&"
import script from "./setting-email.vue?vue&type=script&lang=js&"
export * from "./setting-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7964c04",
  null
  
)

export default component.exports